module.exports = __webpack_public_path__ + "img/6@2x.cc29dd18.png";